/** Shared pure math / beat helpers for creative sampling (renderer-agnostic). */
import type { SourcePack } from "@desk/core";

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function buildBeatRanges(
  pack: SourcePack,
): Array<{ id: string; startTick: number; endTick: number }> {
  return pack.beats.map((b) => ({
    id: b.id,
    startTick: b.startTick,
    endTick: b.endTick,
  }));
}

export function beatAtTick(
  tick: number,
  ranges: Array<{ id: string; startTick: number; endTick: number }>,
) {
  for (const r of ranges) {
    if (tick >= r.startTick && tick < r.endTick) return r;
  }
  return ranges[ranges.length - 1] ?? ranges[0]!;
}
